var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('EditorHeader',{staticClass:"pb-4",attrs:{"title":_vm.$route.params.id ? _vm.$ct("EditHeader") : _vm.$ct("CreateHeader")}}),_c('RunEditor')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }